<script setup>
import { ref } from "vue"
import { useVModels } from "@vueuse/core";
import { PencilSquareIcon } from '@heroicons/vue/24/solid'
import { PrimaryButton, Text, Select } from "@codinglabsau/ui"
import TargetSelector from "../../Components/TargetSelector.vue"
import Modal from "@/Components/Inputs/BlockEditor/Extension/Components/Modal.vue"
import ToolbarButton from "@/Components/Inputs/BlockEditor/Extension/Components/ToolbarButton.vue"

const props = defineProps({
  href: {
    required: true,
  },
  size: {
    required: true,
  },
  padding: {
    required: true,
  },
  target: {
    required: true,
  },
})

let showDialogue = ref(false)

const emits = defineEmits(['update:href', 'update:size', 'update:padding', 'update:target'])

const {
  href: computedHref,
  size: computedSize,
  padding: computedPadding,
  target: computedTarget,
} = useVModels(props, emits)
</script>

<template>
  <ToolbarButton :label="__('Edit Card')" :icon="PencilSquareIcon" v-model="showDialogue"/>
  <Modal v-model="showDialogue">
    <template #title>
      {{ __('Edit Card') }}
    </template>
    <div>
      <label for="href"> {{ __('Link') }} </label>
      <Text
        v-model="computedHref"
        :description="__('Please provide a full url or relative path e.g. \'/auctions/fine-art\'.')"
      />
    </div>
    <TargetSelector v-model="computedTarget"/>
    <div>
      <label for="padding"> {{ __('Padding') }} </label>
      <Select v-model="computedPadding" description="Padding between the edges of the card, image and the content">
        <option value="0">{{ __('None') }}</option>
        <option value="2">{{ __('Small') }}</option>
        <option value="4">{{ __('Medium') }}</option>
        <option value="8">{{ __('Large') }}</option>
      </Select>
    </div>
    <div>
      <label for="cols"> {{ __('Image Size') }} </label>
      <Select v-model="computedSize">
        <option value="10">{{ __('Small') }}</option>
        <option value="16">{{ __('Medium') }}</option>
        <option value="24">{{ __('Large') }}</option>
      </Select>
    </div>
    <PrimaryButton class="mt-2" type="button" @click.prevent="showDialogue = false">{{ __('Done') }}</PrimaryButton>
  </Modal>
</template>
